import dynamic from 'next/dynamic'

export const DynamicActivityPunchCardProgressDrawer = dynamic(
  () => import('.').then((mod) => mod.ActivityPunchCardProgressDrawer),
  { ssr: false },
)
